<template>
  <div v-if="add.bonusOdd !== null && add.bonusOdd !== 0 && window.size.mobile" class="px-2.5 mt-2.5">
    <div class="bg-zt-light-opacity border-zt-light border px-2.5 py-3 w-full rounded-zt">
      <p class="text-xs mb-1.5">{{ add.text }}</p>
      <hr class="border-zt-light mb-2">
      <div class="flex">
        <a class="basis-1/3 text-xs flex flex-col justify-start items-center no-default-style"
           data-count-click="Shortcode Baner do WNŻ - kliki w mecz"  data-count-click-category="football"
           :href="add.is_h2h_enabled ? `/wyniki-pilka-nozna/porownanie-druzyn/${add.localTeam.query_name}/${add.visitorTeam.query_name}/` : null">
          <div class="mr-auto flex items-center mb-1 shrink-0">
                      <span class="inline-block aspect-square h-3.5 overflow-hidden mr-2">
                        <img ref="localTeamImgAdd" class="w-[14px] h-[14px] object-contain mx-auto"
                             :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${add.localTeam.query_name}.png`"
                             :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'" width="14" height="14"/>
                      </span>
            <span class="max-w-full truncate">{{add.localTeam.short_name?.length > 0 ? add.localTeam.short_name : add.localTeam.name}}</span>
          </div>
          <div class="mr-auto flex items-center shrink-0">
                      <span class="inline-block aspect-square h-3.5 overflow-hidden mr-2">
                        <img ref="localTeamImgAdd" class="w-[14px] h-[14px] object-contain mx-auto"
                             :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${add.visitorTeam.query_name}.png`"
                             :alt="'/wp-content/themes/zawodtyper/assets/images/staty_football/teamfallback.svg'" width="14" height="14"/>
                      </span>
            <span class="max-w-full truncate">{{add.visitorTeam.short_name?.length > 0 ? add.visitorTeam.short_name : add.visitorTeam.name}}</span>
          </div>
        </a>
        <div class="basis-1/3 items-center flex justify-center">
          <img class="w-[22px] h-[22px] my-auto mr-2" :src="'/wp-content/themes/zawodtyper/assets/images/bukmacherzy/'+add.bookmaker.toLowerCase()+'-78.webp'" alt="">
          <div class="flex flex-col text-center">
            <span class="text-zt-red font-semibold !leading-[16px]">{{add.bonusOdd}}</span>
            <span class="text-[10px] opacity-40 line-through">{{add.defaultOdd}}</span>
          </div>
        </div>
        <div class="basis-1/3 flex items-center justify-end">
          <a :href="add.link" data-count-click="Shortcode Baner do WNŻ - SZCZEGÓŁY" data-count-click-category="football">
            <div class="zt-button h-7 !py-1.5 !text-xs">SZCZEGÓŁY</div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils_mixin from '../../mixins/utils_mixin';

export default {
  name: "AdFootball",
  mixins: [utils_mixin],
  inject: ['WP'],
  data() {
    return {
      add: {
        startDate: '',
        endDate: '',
        bonusOdd: null,
        defaultOdd: null,
        bookmaker: null,
        text: '',
        link: '',
        is_h2h_enabled: '',
        localTeam: {
          name: '',
          query_name: '',
          short_name: ''
        },
        visitorTeam: {
          name: '',
          query_name: '',
          short_name: ''
        },
      }
    }
  },
  mounted() {
    this.getMatchAddDetails();
  },
  computed: {

  },
  methods: {
    getMatchAddDetails() {
      axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_match_add_details',
      }).then(response => {
        let data = response.data.data
        if (data) {
          this.add.startDate = data.start_date;
          this.add.endDate = data.end_date;
          this.add.bonusOdd = data.bonus_odd;
          this.add.defaultOdd = data.default_odd;
          this.add.bookmaker = data.bookmaker;
          this.add.text = data.text;
          this.add.link = data.link;
          this.add.localTeam.name = data.localteam_name;
          this.add.localTeam.query_name = data.localteam_query_name;
          this.add.localTeam.short_name = data.localteam_short_name;
          this.add.visitorTeam.name = data.visitorteam_name;
          this.add.visitorTeam.query_name = data.visitorteam_query_name;
          this.add.visitorTeam.short_name = data.visitorteam_short_name;
          this.add.is_h2h_enabled = data.is_h2h_enabled;
        }
      })
    }
  }
}
</script>

<style scoped>

</style>